import { render, staticRenderFns } from "./DragAndDropUpload.vue?vue&type=template&id=34d4968e&scoped=true"
import script from "./DragAndDropUpload.vue?vue&type=script&lang=js"
export * from "./DragAndDropUpload.vue?vue&type=script&lang=js"
import style0 from "./DragAndDropUpload.vue?vue&type=style&index=0&id=34d4968e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d4968e",
  null
  
)

export default component.exports